import { useEffect, useState } from "react";
import { Tab, Tabs } from "@mui/material";

import "./FormAssignment.scss";
import JointInspectionAssignment from "./JointInspectionAssignment";
import MaintenanceFormAssignment from "./MaintenanceFormAssignment";

export const peridiocityObj = {
  7: "Weekly",
  14: "Fortnightly",
  30: "Monthly",
  60: "Bi-Monthly",
  90: "Quarterly",
  180: "Half-yearly",
  365: "Yearly",
};
function FormAssignment() {
  const [tabValue, setTabValue] = useState(
    localStorage.getItem("formAssignment") === "Joint Inspection" ? "Joint Inspection" : "Maintenance",
  );

  useEffect(() => {
    localStorage.setItem("formAssignment", tabValue);
  }, [tabValue]);

  return (
    <div className="form-assignment-container">
      <Tabs value={tabValue} onChange={(_, newValue) => setTabValue(newValue)}>
        <Tab label="Maintenance" value={"Maintenance"} />
        <Tab label="Joint Inspection" value={"Joint Inspection"} />
      </Tabs>

      {tabValue === "Maintenance" && <MaintenanceFormAssignment />}
      {tabValue === "Joint Inspection" && <JointInspectionAssignment />}
    </div>
  );
}

export default FormAssignment;
